import React from 'react';
import Hero from '../components/Hero/Hero';
import Featured from '../components/Featured/Featured';

const Home = () => {
    return (
        <>
            <Hero />
            {/* <Featured /> */}
        </>
    );
};

export default Home;